import config from '../../../config/config';
import getRequest from '../base/get';

/**
 * Query parameters interface for EMSP Preauth API calls.
 */
interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

const emspPreauthApi = {
  /**
   * Fetch EMSP Preauth list with pagination, filters, and sorting.
   * @param {QueryParameters} query - The query parameters for fetching preauths.
   * @returns {Promise<any>} Promise resolving to the preauth response.
   */
  fetchPreauthList: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query, limit: query?.limit || 20 };
    return getRequest(`${config.emsp.emspApiUrl}api/v2/preauth`, parameters);
  },
  /**
   * Fetch filter options for EMSP Preauth.
   * @returns {Promise<any>} Promise resolving to list filters.
   */
  fetchPreauthListFilters: (): Promise<any> => {
    return getRequest(`${config.emsp.emspApiUrl}api/v2/preauth/list-filters`);
  },
  /**
   * Export EMSP Preauth data.
   * @param {QueryParameters} query - The query parameters for export.
   * @returns {Promise<any>} Promise resolving to export data.
   */
  fetchPreauthExport: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.emsp.emspApiUrl}api/v2/preauth/export`, parameters);
  },
  /**
   * Fetch status counts for EMSP Preauth.
   * @param {QueryParameters} query - The query parameters for status counts.
   * @returns {Promise<any>} Promise resolving to status counts response.
   */
  fetchPreauthStatusCounts: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { paymentMethod: 'card', ...query };
    return getRequest(`${config.emsp.emspApiUrl}api/v2/preauth/status-counts`, parameters);
  },
};

export default emspPreauthApi;
